<template>
    <div id="AdministracionNovedad" v-if="$store.state.global_esAdmin"> 
     <AdminMenu />
     <div class="row justify-content-md-center">
      <div class="col-md-11">
        <div class="row container_admin">
          <!-- NUEVA NOVEDAD -->
          <div class="col-12 text-left mt-2">
            <b class="titulo">Nueva Novedad</b>
          </div>
          <div class="col-12">
            <div class="row me-0 ms-0">
                <div class="col-md-6 mb-3">
                    <ul class="nav nav-tabs mt-2 mb-3" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="datos-generales-novedad-tab" data-toggle="tab" data-target="#datos-generales-novedad" type="button" role="tab" aria-controls="home" aria-selected="true">Datos Generales</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="secciones-novedad-tab" data-toggle="tab" data-target="#secciones-novedad" type="button" role="tab" aria-controls="profile" aria-selected="false">Secciones</button>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="datos-generales-novedad" role="tabpanel" aria-labelledby="datos-generales-novedad-tab">
                            <div class="mb-3">
                                <label
                                    :class="{ 'text-danger': $v.novedad.titulo.$error && enviarEstado === 'Error' }">Título</label>
                                <textarea v-model="$v.novedad.titulo.$model" class="form-control"
                                    :class="{ 'border border-danger': $v.novedad.titulo.$error && enviarEstado === 'Error' }"
                                    rows="2" wrap="soft" placeholder="Título"></textarea>
                            </div>
                            <div class="mb-3">
                                <label
                                    :class="{ 'text-danger': $v.novedad.descripcion.$error && enviarEstado === 'Error' }">Descripción</label>
                                <textarea v-model="$v.novedad.descripcion.$model" class="form-control"
                                    :class="{ 'border border-danger': $v.novedad.descripcion.$error && enviarEstado === 'Error' }"
                                    rows="2" wrap="soft" placeholder="Descripción"></textarea>
                            </div>
                            <div v-if="enviarEstado === 'Error'">
                                <small class="text-danger fw-bold mt-3">
                                    ¡Completa todos los campos obligatorios!
                                </small>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="secciones-novedad" role="tabpanel" aria-labelledby="secciones-novedad-tab">
                            <div class="mb-3">
                                <label
                                    :class="{ 'text-danger': enviarEstado2 === 'Error' && !seccion.categoria }">Categoría</label>
                                <select class="form-control"
                                    :class="{ 'border border-danger': enviarEstado2 === 'Error' && !seccion.categoria }"
                                    v-model="seccion.categoria">
                                    <option class="text-dark" value="" disabled selected>
                                        Selecciona una opción
                                    </option>
                                    <option class="text-dark" value="Diseño">Diseño</option>
                                    <option class="text-dark" value="Funcionalidad">Funcionalidad</option>
                                    <option class="text-dark" value="RiskMann-Tip">IPER-Tip</option>
                                    <option class="text-dark" value="Bug">Bug</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <label
                                    :class="{ 'text-danger': enviarEstado2 === 'Error' && !seccion.titulo }">Título</label>
                                <textarea
                                    :class="{ 'border border-danger': enviarEstado2 === 'Error' && !seccion.titulo }"
                                    v-model="seccion.titulo" class="form-control" rows="2" wrap="soft"
                                    placeholder="Título" required></textarea>
                            </div>
                            <div class="mb-3">
                                <label
                                    :class="{ 'text-danger': enviarEstado2 === 'Error' && !seccion.descripcion }">Contenido</label>
                                <EditorTexto :contenido="seccion.descripcion" :estado="enviarEstado2"
                                    @contenido="obtenerContenido" />
                            </div>
                            <div class="mb-3 text-left" >
                                <label :class="{ 'text-danger': enviarEstado2 === 'Error' && !seccion.imagen.url }">
                                    <b>Imagen</b></label> <br>
                                <label class="file-drop-zone" for="file-upload">
                                    <i class="fa fa-cloud-upload"></i> Seleccionar Archivo
                                </label>
                                <input type="file" id="file-upload" accept="image/*" style="display:none;" @change="adjuntarArchivo($event.target.files[0])">
                            </div>
                            <div>
                                <p v-if="seccion.imagen.nombre" :class="{ 'text-success': seccion.imagen.url }">
                                    <b class="limit-text fw-normal">{{ seccion.imagen.nombre }}</b>
                                    <button type="button" class="btn" :class="{ 'text-success': seccion.imagen.url }" data-toggle="modal" data-target="#modalImagen">
                                        <i class="fas fa-images"></i>
                                    </button>
                                </p>
                            </div>
                            <div v-if="enviarEstado2 === 'Error'" class="mb-3">
                                <small class="text-danger fw-bold mt-3">
                                    ¡Completa todos los campos obligatorios!
                                </small>
                            </div>
                            <div class="row">
                                <div :class="{
                                    'col-md-12': !esEditar,
                                    'col-md-6': esEditar
                                }">
                                    <button type="button" class="btn btn-success w-100"
                                        @click="altenarSeccion()" :disabled="enviarEstado2 === 'Ok'">
                                        {{ esEditar ? 'Guardar Cambios' : 'Agregar Sección' }}
                                    </button>
                                </div>
                                <div v-if="esEditar" class="col-md-6">
                                    <button type="button" class="btn btn-danger w-100"
                                        @click="limpiarSeccion()">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-3 text-left">
                    <h3 class="text-center rounded" style="background-color: azure;">
                        Vista Previa
                    </h3>
                    <h5 class="fw-bold">{{ novedad.titulo }}</h5>
                    <p style="white-space: pre-line;">
                        {{ novedad.descripcion }}
                    </p> 

                    <div class="scroll-preview">
                        <div class="accordion" id="secciones">
                            <div v-for="(seccion, index) of novedad.secciones"
                                :key="index">
                                <h3 class="card-header" :id="'heading-' + index">
                                    <button class="btn btn-link" type="button"
                                        data-toggle="collapse" :data-target="'#collapse-' + index"
                                        aria-expanded="true" :aria-controls="'collapse-' + index">
                                        <b><u>Sección # {{ index + 1 }} - {{ seccion.titulo }}</u></b>
                                    </button>
                                </h3>
                                <div :id="'collapse-' + index" class="accordion-collapse collapse"
                                    :aria-labelledby="'heading-' + index" data-parent="#secciones">
                                    <div class="card-body">
                                        <span class="badge mb-1" style="background-color: #EE8813; color: white;">{{
                                            seccion.categoria.toUpperCase()
                                        }}</span>
                                        <div class="p-1" v-html="seccion.descripcion"></div>
                                        <img :src="seccion.imagen.url" class="img-fluid" />
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end me-2 mt-2 mb-2">
                                    <button type="button" class="btn btn-success btn-sm"
                                        @click="obtenerSeccion(seccion, index)">
                                        <i class="fas fa-edit ml-2"></i> Editar
                                    </button>&nbsp;
                                    <button type="button" class="btn btn-danger btn-sm ms-2"
                                        @click="eliminarSeccion(index)">
                                        <i class="fas fa-trash ml-2"></i> Eliminar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
            <div class="row me-0 ms-0">
                <div class="col-md-12">
                    <hr />
                </div>
                <div class="col-md-6 mb-3">
                    <router-link :to="{ name: 'AdministracionNovedades' }">
                        <button type="button" class="btn btn-secondary w-100">Cancelar</button>
                    </router-link>
                </div>
                <div class="col-md-6 mb-3">
                    <button type="button" class="btn w-100" @click="alternarNovedad()" style="background-color: #EE8813; color: white;"
                        :disabled="enviarEstado === 'Ok'">
                        {{ $route.params.id ? 'Guardar Cambios' : 'Guardar & Finalizar' }}
                    </button>
                </div>
            </div>
           </div> 
           <!-- Modal -->
            <div class="modal fade" id="modalImagen" tabindex="-1" aria-labelledby="modalImagenLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-header text-right">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <img :src="seccion.imagen.url" class="card-img-top" alt="...">
                    </div>
                    </div>
                </div>
            </div> 
        </div> 
       </div>
      </div>
    </div> 
</template>  
<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, db } from "@/firebase";
import { storage } from '@/firebase';
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import Vue from 'vue'
import  { Vuelidate }  from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import EditorTexto from "@/components/Generales/EditorTexto.vue";
Vue.use(Vuelidate)

export default {
    name: "AdministracionNovedad",
    components: {
        AdminMenu,
        EditorTexto,
    },
    data() {
        return {
            novedad: {
                id: "",
                titulo: "",
                descripcion: "",
                secciones: [],
                registro: {
                    idUsuario: "",
                    estado: "Creado",
                    creacion: firebase.firestore.FieldValue.serverTimestamp(),
                    actualizacion: firebase.firestore.FieldValue.serverTimestamp(),
                }
            },
            seccion: {
                categoria: "",
                titulo: "",
                descripcion: "",
                imagen: {
                    url: "",
                    nombre: "",
                    tipo: "",
                }
            },
            indice: 0,
            esEditar: false,
            enviarEstado: null,
            enviarEstado2: null,
        };
    },
    validations: {
        novedad: {
            titulo: {
                required
            },
            descripcion: {
                required
            }
        }
    },
    created() {
        if(this.$store.state.global_esAdmin){
            if (this.$route.params.id) {
                this.novedad.id = this.$route.params.id;
                this.obtenerNovedad();
            } else {
                this.novedad.registro.idUsuario = this.$store.state.id;
                this.generarID();
            }
        }
    },
    methods: {
        async obtenerNovedad() {
            var docRef = db.collection("novedades").doc(this.novedad.id);

            docRef.get().then((doc) => {
                if (doc.exists) {
                    this.novedad = doc.data();
                    console.log("Document data:", doc.data());
                }
            });
        },

        generarID() {
            const refNovedad = db.collection("novedades").doc();
            this.novedad.id = refNovedad.id;
        },

        obtenerContenido(data) {
            this.seccion.descripcion = data;
        },

        altenarSeccion() {
            if (
                !this.seccion.categoria ||
                !this.seccion.titulo ||
                !this.seccion.descripcion ||
                this.seccion.descripcion === '<p class="ql-align-justify"><br></p>' ||
                !this.seccion.imagen.url
            ) {
                this.enviarEstado2 = 'Error';
            } else {
                this.enviarEstado2 = 'Ok';
                this.$isLoading(true);
                if (!this.esEditar) {
                    this.novedad.secciones.push(this.seccion);
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "¡Sección agregada correctamente!",
                        showConfirmButton: false,
                        timer: 1500
                    });
                } else {
                    this.novedad.secciones.splice(this.indice, 1, this.seccion);
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "¡Sección editada correctamente!",
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
                this.$isLoading(false);
                this.limpiarSeccion();
            }
        },

        obtenerSeccion(seccion, index) {
            this.esEditar = true;
            this.indice = index;
            this.seccion = JSON.parse(JSON.stringify(seccion));
        },

        eliminarSeccion(index) {
            Swal.fire({
                icon: "info",
                background: 'rgba(255, 255, 255)',
                backdrop: `rgba(0,0,0,0.7)`,
                title: "<h6 class='text-dark'><b style='font-size: 13pt !important'>¡Una vez eliminada la sección, no se podrá recuperar!</h6>",
                html: "<p class='text-dark'>¿Estás seguro que deseas eliminar esta sección?</p>",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                cancelButtonText: "Cancelar",
                reverseButtons: false,
                customClass: {
                    confirmButton: "btn btn-primary btn-md fw-bold me-2 mb-3",
                    cancelButton: "btn btn-secondary btn-md fw-bold mb-3",
                },
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.value) {
                    this.novedad.secciones.splice(index, 1);
                    // this.$store.state.alerta("success", "¡Sección eliminada correctamente!");
                    Swal.fire({
                        position: "top-center",
                        icon: "success",
                        title: "¡Sección eliminada correctamente!",
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            });
        },

        limpiarSeccion() {
            this.seccion = {
                categoria: "",
                titulo: "",
                descripcion: "",
                imagen: {
                    url: "",
                    nombre: "",
                    tipo: "",
                }
            };
            this.esEditar = false;
            this.enviarEstado2 = null;
            this.indice = 0;
        },

        // AÑADIR NOVEDAD
        async alternarNovedad() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.enviarEstado = "Error";
            } else {
                this.enviarEstado = null;
                if (this.novedad.secciones.length === 0) {
                    Swal.fire({
                        position: "top-center",
                        icon: "error",
                        title: "¡Debes agregar al menos una sección!",
                        showConfirmButton: false,
                        timer: 1500
                    });
                } else {
                    this.enviarEstado = "Ok";
                    this.$isLoading(true);
                    if (this.$route.params.id) {
                        this.novedad.registro.actualizacion = firebase.firestore.FieldValue.serverTimestamp();
                        var washingtonRef = db.collection("novedades").doc(this.novedad.id);
                        return washingtonRef.update(this.novedad)
                        .then(() => {
                            console.log("Document successfully updated!");
                            this.$isLoading(false);
                            this.enviarEstado = null;
                            Swal.fire({
                                icon: 'success',
                                background: 'rgba(255, 255, 255)',
                                backdrop: `rgba(0,0,0,0.7)`,
                                title: `<h6 class='text-dark'>¡Novedad editada correctamente!</h6>`,
                                buttonsStyling: false,
                                confirmButtonText: "Entendido",
                                reverseButtons: false,
                                customClass: {
                                    confirmButton: "btn btn-primary btn-md fw-bold mb-2",
                                },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push('/administracion/novedades')
                                }
                            });
                        });
                    } else {
                        var citiesRef = db.collection("novedades");
                        citiesRef.doc(this.novedad.id).set(this.novedad);
                        this.$isLoading(false);
                        this.enviarEstado = null;
                        Swal.fire({
                            icon: 'success',
                            background: 'rgba(255, 255, 255)',
                            backdrop: `rgba(0,0,0,0.7)`,
                            title: `<h6 class='text-dark'>¡Novedad creada correctamente!</h6>`,
                            buttonsStyling: false,
                            confirmButtonText: "Entendido",
                            reverseButtons: false,
                            customClass: {
                                confirmButton: "btn btn-primary btn-md fw-bold mb-2",
                            },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push('/administracion/novedades')
                            }
                        });
                    }
                }
            }
        },

        /*  funcion de la url de la imagen  */
        async adjuntarArchivo(file) {
            this.seccion.imagen.nombre = file.name;
            this.$isLoading(true);
            this.seccion.imagen.tipo = "Imagen",
            this.url = URL.createObjectURL(file);
            
            let urlDescarga;
            const archivoRef = storage.ref().child(`files/novedades/${new Date()}` + file.name);
            
            try {
                // Subir el archivo al almacenamiento
                urlDescarga = await archivoRef.put(file);
                // Obtener la URL de descarga del archivo
                const downloadURL = await archivoRef.getDownloadURL();
                this.seccion.imagen.url = downloadURL
                Swal.fire({
                    icon: "success",
                    title: "¡Imagen adjuntada!",
                    showConfirmButton: false,
                    timer: 1900,
                    customClass: {
                        popup: "swal2-border-radius",
                    },
                });
            } catch (error) {
                console.error('Error al subir el archivo:', error);
            }         
            this.$isLoading(false);
        },
    },
};
</script>
<style scoped>
.custom-file-upload {
  border: 1px solid red;
  padding: 9px 46px;
  cursor: pointer;
  border-radius: 2px;
  border-style:dashed
}

.custom-file-upload:hover {
  background-color: #e5e5e5;
}

.custom-file-upload i {
  margin-right: 5px;
}
.file-drop-zone {
    border: 2px dashed #073d7a;
    padding: 0.25rem;
    text-align: center;
    cursor: pointer;
    font-size: 12pt;
    color: #073d7a
}
.file-drop-zone.success {
    border: 2px dashed green;
    background-color: rgba(140, 205, 165, 0.3);
}
</style>